module.exports = __webpack_public_path__ + "web/img/discuss-bg.05c156f7.png";